export default __webpack_public_path__ + "static/selfapp-footer-b1ace3104cafeea3f12450f07a26720c.jpg";